import { render } from "./ReuniãoAprovação.vue?vue&type=template&id=d8babfd6&scoped=true"
import script from "./ReuniãoAprovação.vue?vue&type=script&lang=js"
export * from "./ReuniãoAprovação.vue?vue&type=script&lang=js"

import "./ReuniãoAprovação.vue?vue&type=style&index=0&id=d8babfd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8babfd6"]])

export default __exports__